export default __webpack_public_path__ + "static/media/flow_1.74629ba7.jpg";